module.exports = __webpack_public_path__ + "img/circle_num_3.ad0dfa6b.svg";